const Loading = () => {
    return ( 
        <div className="cont">
            <div className="circle">
                <div className="quarter"></div>
                <div className="quarter"></div>
                <div className="quarter"></div>
                <div className="quarter"></div>
            </div>
        </div>
     );
}
 
export default Loading;